module.exports = __webpack_public_path__ + "img/fondoServicios1.dc1ae9bc.svg";